import React from 'react'

import { Col, Grid } from '../structure/Grid'
import ConditionalLink from '../actions/ConditionalLink'
import Line from '../helpers/Line'
import Separator from '../helpers/Separator'

const ListItem = ({
  children,
  onClick,
  path,
  rightContent,
  leftContent,
  bgColor,
  hoverBgColor,
  gap,
  tooltip,
  ...props
}) => {
  return (
    <div className="listItem" title={tooltip}>
      <ConditionalLink onClick={onClick} path={path} block width="100%" tabIndex="-1">
        <Separator weight={2.5} bgColor={bgColor} hoveBgColor={hoverBgColor} usePadding>
          <Grid justify="space-between" align="center" gap={gap || 0.3} paddingH={0} {...props}>
            {leftContent && <Col>{leftContent}</Col>}
            <Col flex={1}>{children}</Col>
            {rightContent && <Col>{rightContent}</Col>}
          </Grid>
        </Separator>
      </ConditionalLink>
      <Line color="light1" />
    </div>
  )
}

export default ListItem
